import api from './api';

// Biztimize Notes on the tenant host (apps/kb_tenant). The reader pages live on
// the Help Center host under /notes/ and are reached through the Support Desk
// SSO bridge, exactly like /help/ — see openNotesPage().
const BASE_URL = '/kb/api';

const knowledgeService = {
  // Reading (audience decided by the server)
  searchNotes: (params) => api.get(`${BASE_URL}/notes/search/`, { params }),
  getNote: (number) => api.get(`${BASE_URL}/notes/${number}/`),
  notesForScreen: (path) => api.get(`${BASE_URL}/notes/for-screen/`, { params: { path } }),
  notesForErrorCode: (code) => api.get(`${BASE_URL}/notes/error-code/${encodeURIComponent(code)}/`),

  // Note Assistant (kb.view_note_assistant / kb.change_note_status)
  getAssistant: () => api.get(`${BASE_URL}/assistant/`),
  getAssistantNotes: (status) => api.get(`${BASE_URL}/assistant/notes/`, { params: status ? { status } : {} }),
  completeStep: (number, seq, remarks) =>
    api.post(`${BASE_URL}/assistant/notes/${number}/steps/${seq}/complete/`, { remarks }),
  confirmNotApplicable: (number, reason) =>
    api.post(`${BASE_URL}/assistant/notes/${number}/not-applicable/`, { reason }),
  reopen: (number) => api.post(`${BASE_URL}/assistant/notes/${number}/reopen/`),
  downloadActionsPdf: () => api.get(`${BASE_URL}/assistant/pdf/`, { responseType: 'blob' }),

  // HotNews (kb.acknowledge_hotnews)
  getPendingHotNews: () => api.get(`${BASE_URL}/hotnews/`),
  acknowledgeHotNews: (number) => api.post(`${BASE_URL}/hotnews/${number}/acknowledge/`),
};

/**
 * Open a Biztimize Notes page (/notes/..., Help Center host) through the SSO
 * bridge. `sameTab` replaces the current page — used by the /knowledge/* bounce
 * routes that e-mails and the assistant link to.
 */
export async function openNotesPage(nextPath = '/notes/', { sameTab = false } = {}) {
  try {
    const { data } = await api.get(`/support/api/sso-token/?next=${encodeURIComponent(nextPath)}`);
    if (data?.sso_url) {
      if (sameTab) window.location.replace(data.sso_url);
      else window.open(data.sso_url, '_blank', 'noopener,noreferrer');
      return true;
    }
  } catch (err) {
    console.error('Biztimize Notes SSO failed:', err);
  }
  return false;
}

export const notePath = (number) => `/notes/${number}/`;

export default knowledgeService;
